export default {
  processing: {
    title: 'Video is being processed',
    text: "This video is currently being processed. It's ready in a little while."
  },
  downloadButton: 'Download clip',
  readyBottonSoon: 'Download ready in a little while'
}